import { MealPayload } from '../Components/TrackerWidget';

// const API_URL = 'https://7842-18-210-162-168.ngrok-free.app';
const API_URL = 'https://dev-gateway.myorganicapps.com';
// const API_URL = 'http://localhost:3000';

const postMeal = async ({ payload, userEmail }: { payload: MealPayload; userEmail: string }) => {
  const response = await fetch(`${API_URL}/track`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: userEmail,
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error('Failed to post meal');
  }
  return response.json();
};

const getTracks = async (userEmail: string) => {
  const response = await fetch(`${API_URL}/track`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: userEmail,
    },
  });
  if (!response.ok) {
    throw new Error('Failed to post meal');
  }
  return response.json();
};

const getStats = async (userEmail: string) => {
  const response = await fetch(`${API_URL}/track/stats`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: userEmail,
    },
  });
  if (!response.ok) {
    throw new Error('Failed to post meal');
  }
  return response.json();
};

const saveUserSettings = async (data: any) => {
  const response = await fetch(`${API_URL}/track/settings`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error('Failed to post meal');
  }
  return response.json();
};

export { postMeal, getTracks, getStats, saveUserSettings };
